import React, { FC } from 'react';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import IngkaDropdownMenu from '../IngkaDropdownMenu';
import { ListBoxFooter } from '@ingka/list-box';
import Button from '@ingka/button';

const ColumnsButton: FC = () => {
  const apiRef = useGridApiContext();

  const columns = apiRef.current
    .getAllColumns()
    .map((column) => ({ label: column.headerName, value: column.field }))
    .filter((c) => !c.label.includes('Utility'));

  const visibleColumns = apiRef.current
    .getVisibleColumns()
    .map((column) => column.field);

  const onColumnToggle = (columnName) => {
    const remove = visibleColumns.includes(columnName);
    if (remove) {
      apiRef.current.setColumnVisibility(columnName, false);
    } else {
      apiRef.current.setColumnVisibility(columnName, true);
    }
  };

  const hideAll = () => {
    const visibilityModel = {};
    columns.forEach((c) => (visibilityModel[c.value] = false));
    apiRef.current.setColumnVisibilityModel(visibilityModel);
  };
  const showAll = () => {
    const visibilityModel = {};
    columns.forEach((c) => (visibilityModel[c.value] = true));
    apiRef.current.setColumnVisibilityModel(visibilityModel);
  };

  return (
    <IngkaDropdownMenu
      label={'Columns'}
      limitedHeight
      options={columns}
      selectedValues={visibleColumns}
      onToggle={onColumnToggle}
      id={'datagrid-columns-button'}
      addSearch
      footer={
        <ListBoxFooter>
          <Button
            fluid
            size={'small'}
            type="secondary"
            text="Hide All"
            onClick={hideAll}
          />
          <Button
            fluid
            size={'small'}
            type="secondary"
            text="ShowAll"
            onClick={showAll}
          />
        </ListBoxFooter>
      }
    />
  );
};

export default ColumnsButton;
